import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import centerSvg from '@/images/toolbar/avatar-align/Center.svg';
import leftSvg from '@/images/toolbar/avatar-align/Left.svg';
import rightSvg from '@/images/toolbar/avatar-align/Right.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getAvatarElementFromPage, getAvatarGroupFromPage } from '@/pages/AdvancedEditor/utils';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ControlButton } from '../../../common/ControlButton';
import { alignPosition } from './position';

const Container = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
`;

export const PositionControl = observer(() => {
    const { store } = useAdvancedEditorContext();

    const handleClick = (action: string) => {
        const avatarElement = getAvatarElementFromPage(store?.activePage);

        if (!avatarElement) {
            return;
        }

        const group = getAvatarGroupFromPage(store.activePage);

        if (group) {
            return alignPosition({ position: action, elements: group.children, storeWidth: store.width });
        }

        alignPosition({ position: action, elements: [avatarElement], storeWidth: store.width });
    };

    return (
        <Container>
            <ControlButton onClick={() => handleClick('left')} selected={false}>
                <MaskedIcon src={leftSvg} size="20px" />
            </ControlButton>
            <ControlButton onClick={() => handleClick('center')} selected={false}>
                <MaskedIcon src={centerSvg} size="20px" />
            </ControlButton>
            <ControlButton onClick={() => handleClick('right')} selected={false}>
                <MaskedIcon src={rightSvg} size="20px" />
            </ControlButton>
        </Container>
    );
});
